// Machine cards use individual operations; order rows can group parallel workers.
export function machineProductionJobs(legacy: any[], integrated: any[]) {
  return [
    ...legacy.filter((job) => !job.order_line_id),
    ...integrated.map((job) => ({
      ...job,
      integrated: true,
      unit: job.line_unit,
    })),
  ].filter(
    (job) =>
      job.machine_id &&
      !["PLANNED", "COMPLETED", "CANCELLED"].includes(job.status) &&
      !["QUEUED", "INTERRUPTED"].includes(job.dispatch_state),
  );
}

export function taskForMachine(tasks: any[], machineId?: string) {
  if (!machineId) return undefined;
  return tasks.find((task) =>
    task.tv_people
      ? task.tv_people.some((person: any) => person.machine_id === machineId)
      : task.machine_id === machineId,
  );
}

export function progressRequestPath(operationId: string, orderId?: string) {
  return orderId
    ? `/integrated/orders/${orderId}/request-report`
    : `/operations/${operationId}/request-progress`;
}
